import React from "react";
import { trackFunnelExit } from "../utils/funnelTracking";
import "./PremiumContactStrip.css";

const SUPPORT_CALL_HREF = "tel:+441628665040";
const SUPPORT_WHATSAPP_HREF = "https://api.whatsapp.com/send?phone=447593308428";
const SUPPORT_EMAIL_HREF = "mailto:support@cheapcabgrab.com";

const contactOptions = [
  {
    key: "need-help",
    icon: "?",
    title: "Need help",
    body: "Live chat support",
    action: "chat",
    primary: true,
  },
  {
    key: "whatsapp",
    icon: "WA",
    title: "WhatsApp",
    body: "Chat with us",
    href: SUPPORT_WHATSAPP_HREF,
  },
  {
    key: "email",
    icon: "@",
    title: "Email us",
    body: "Send a message",
    href: SUPPORT_EMAIL_HREF,
  },
  {
    key: "call",
    icon: "TEL",
    title: "Call us",
    body: "Speak to our team",
    href: SUPPORT_CALL_HREF,
  },
];

const openSupportChat = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("ccg:open-support-chat", { detail: { flow: "enquiry" } }));
};

const PremiumContactStrip = ({
  trackingContext = {},
  className = "",
  tone = "dark",
  title = "Need help or prefer to talk?",
}) => (
  <section className={`premium-contact-strip premium-contact-strip-${tone} ${className}`} aria-label={title}>
    <div className="premium-contact-strip-title">
      <span />
      <strong>{title}</strong>
      <span />
    </div>

    <div className="premium-contact-strip-grid">
      {contactOptions.map((option) => {
        const content = (
          <>
            <b className={`premium-contact-strip-icon is-${option.key}`}>{option.icon}</b>
            <span>
              <strong>{option.title}</strong>
              <small>{option.body}</small>
            </span>
          </>
        );

        if (option.action === "chat") {
          return (
            <button
              type="button"
              className="premium-contact-strip-option is-primary"
              onClick={openSupportChat}
              key={option.key}
            >
              {content}
            </button>
          );
        }

        return (
          <a className="premium-contact-strip-option" href={option.href} key={option.key}
            onClick={() => { if (option.key === "whatsapp") trackFunnelExit("whatsapp_click", { ...trackingContext, source: "support_strip", conversion_role: "engagement" }); }}>
            {content}
          </a>
        );
      })}
    </div>
  </section>
);

export default PremiumContactStrip;
